import ApiService from './api.service';

// eslint-disable-next-line import/prefer-default-export
export async function getRequestVerificationTypes() {
  const path = `${window.ambulnzConfig.tenantedRestApiV2Url}/RequestVerificationTypes`;
  const response = await ApiService.get(path);

  return response.json();
}
